import React from 'react';
import { motion } from 'framer-motion';
export function FinalClose() {
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-800 border-t border-white/10 relative overflow-hidden pb-16 md:pb-32" data-id="element-26">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gold-500/10 rounded-t-full blur-3xl -z-10 pointer-events-none" data-id="element-27"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-8 md:mb-12" data-id="element-30">
            Tienes dos opciones:
          </h2>

          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-31">
            <div className="bg-navy-900/80 p-5 md:p-8 rounded-xl border border-red-500/20 text-left" data-id="element-32">
              <div className="text-red-400 font-bold mb-4 flex items-center" data-id="element-33">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 mr-2" data-id="element-34">
                  <line x1="18" y1="6" x2="6" y2="18" data-id="element-35"></line>
                  <line x1="6" y1="6" x2="18" y2="18" data-id="element-36"></line>
                </svg>
                Opción 1
              </div>
              <p className="text-gray-400 font-light" data-id="element-37">
                Seguir gritando en el vacío con videos aburridos que el mercado
                ignora.
              </p>
            </div>

            <div className="bg-navy-900/80 p-5 md:p-8 rounded-xl border border-gold-500/30 text-left relative overflow-hidden" data-id="element-38">
              <div className="absolute inset-0 bg-gold-500/5" data-id="element-39"></div>
              <div className="text-gold-500 font-bold mb-4 flex items-center relative z-10" data-id="element-40">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 mr-2" data-id="element-41">
                  <polyline points="20 6 9 17 4 12" data-id="element-42"></polyline>
                </svg>
                Opción 2
              </div>
              <p className="text-white font-medium relative z-10" data-id="element-43">
                Hacer una inversión simbólica hoy y empezar a ser percibido como
                la autoridad que realmente eres.
              </p>
            </div>
          </div>

          <p className="text-lg md:text-xl text-gray-300 font-light mb-6 md:mb-10" data-id="element-44">
            La decisión de compromiso se toma{' '}
            <span className="text-white font-bold" data-id="element-45">ahora</span>.
          </p>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto px-6 py-4 md:px-10 md:py-6 bg-gradient-to-r from-gold-600 to-gold-500 text-navy-900 font-black text-lg md:text-2xl rounded-xl shadow-xl hover:shadow-gold-500/30 transition-all duration-300 animate-pulse-glow uppercase tracking-wider" data-id="element-46">
            Sí, Quiero el Edutainment OS por $6.36
          </motion.button>
        </motion.div>
      </div>
    </section>;
}